exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar[data-v-33b1a140]{background-color:#008ba3!important}.navbar ul.list-unstyled[data-v-33b1a140]{margin-bottom:0}.navbar .link[data-v-33b1a140],.navbar a[data-v-33b1a140]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33b1a140","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App/PageFooter.vue
// module id = 1165
// module chunks = 24